/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ListingMetrics_ListingMetricsUpdate_metrics_read = {
    listingId?: string;
    listingType?: ListingMetrics_ListingMetricsUpdate_metrics_read.listingType;
};
export namespace ListingMetrics_ListingMetricsUpdate_metrics_read {
    export enum listingType {
        COUNTRY = 'country',
        CITY = 'city',
        REGION = 'region',
        LEGACY_COUNTRY = 'legacy_country',
        LEGACY_VOIDESHIP = 'legacy_voideship',
        LEGACY_CITY = 'legacy_city',
        LEGACY_REGION = 'legacy_region',
    }
}
